import { LinkOff, MiscellaneousServices } from '@mui/icons-material'
import { SvgIcon, useTheme } from '@mui/material'

import { Switch } from 'features/alerts/components/Alerts/types'
import { DomainAlert } from 'features/inventory/domain/types/DomainAlert'
import AbTest from 'images/icons/ab-tests.svg?react'
import CustomBranch from 'images/icons/custom-branch.svg?react'
import { useAbility } from 'providers/casl'
import { DOMAIN_REBUILD_ALERT_URL } from './constants'

type UseAlerts = {
  switcher: Switch<DomainAlert>
}

export const useAlerts = (): UseAlerts => {
  const ability = useAbility()
  const theme = useTheme()

  const switcher: UseAlerts['switcher'] = alert => {
    switch (alert.name) {
      case 'abTestActive':
        return {
          color: theme.palette.info.main,
          Icon: (
            <SvgIcon
              component={AbTest}
              inheritViewBox
            />
          ),
          tooltip: {
            text: alert.description,
          },
        }
      case 'customBranch':
        return ability.can('read', 'DomainFeature-alert-customBranch')
          ? {
              color: theme.palette.info.main,
              Icon: (
                <SvgIcon
                  component={CustomBranch}
                  inheritViewBox
                />
              ),
              tooltip: {
                text: alert.description,
              },
            }
          : undefined
      case 'rebuildFailed':
        return {
          color: theme.palette.error.main,
          Icon: <MiscellaneousServices data-cy='miscellaneous-services-icon' />,
          tooltip: {
            link: DOMAIN_REBUILD_ALERT_URL,
            text: alert.description,
          },
        }
      case 'rebuildInProgress':
        return {
          color: theme.palette.warning.main,
          Icon: <MiscellaneousServices data-cy='miscellaneous-services-icon' />,
          tooltip: {
            link: DOMAIN_REBUILD_ALERT_URL,
            text: alert.description,
          },
        }
      case 'scriptInactive':
        return {
          color: theme.palette.error.main,
          Icon: <LinkOff data-cy='link-off-icon' />,
          tooltip: {
            text: alert.description,
          },
        }
      default:
        throw Error('Missing alert config')
    }
  }

  return { switcher }
}
